import type {
    SelectionDropdown,
    SelectionDropdownItem,
} from "app/pages/sales-intelligence/common-components/table-actions-panel";
import { getItemWithTheBiggestValueOrManual } from "app/pages/sales-intelligence/common-components/table-actions-panel";
import AllXResultsSelectionItem from "app/pages/sales-intelligence/modules/company-analysis/models/table-actions-panel/AllXResultsSelectionItem";
import TopNSelectionItem from "app/pages/sales-intelligence/modules/company-analysis/models/table-actions-panel/TopNSelectionItem";
import { CONTACTS_SELECTION_RESULTS_LIMIT } from "app/pages/sales-intelligence/sub-modules/contacts-search/constants/actions-panel";

const TOP_N_VALUES = [10, 25, 50, 100, 250];

const exportSelectionDropdown: SelectionDropdown = {
    getInitiallySelectedItem: getItemWithTheBiggestValueOrManual,
    getItems<Item extends SelectionDropdownItem = SelectionDropdownItem>(
        numberOfResults: number,
        limit = Number.POSITIVE_INFINITY,
        mapLimitedListOfItems?: (listOfItems: readonly number[]) => readonly Item[],
    ): readonly Item[] | readonly SelectionDropdownItem[] {
        if (numberOfResults === 0 || numberOfResults > CONTACTS_SELECTION_RESULTS_LIMIT) {
            return [];
        }

        if (mapLimitedListOfItems) {
            return mapLimitedListOfItems(TOP_N_VALUES);
        }

        const maximumValue = Math.min(numberOfResults, limit);
        const topNValuesLessThanEqualMaximum = TOP_N_VALUES.filter((value) => value <= maximumValue);
        const topNItems: SelectionDropdownItem[] = topNValuesLessThanEqualMaximum.map((value) => {
            return new TopNSelectionItem({ value, id: `top-${value}` });
        });
        const biggestTopNValue = topNValuesLessThanEqualMaximum.at(-1);

        if (maximumValue > (biggestTopNValue ?? 0)) {
            const allItem = new AllXResultsSelectionItem(maximumValue);

            return topNItems.concat(allItem);
        }

        return topNItems;
    },
};

export default exportSelectionDropdown;
